import { IkemTraining } from '../constants/ikemTraining';

// The announcement disappears on its own once the training is over, so a past
// event is never advertised if nobody gets around to removing it. The
// prerendered markup is a build-time snapshot; when it goes stale, hydration
// re-renders and drops the announcement on the client.
export const isIkemTrainingAnnounced = (): boolean => new Date() <= new Date(IkemTraining.hideAfter);

/** Registration closes before the training itself, see constants/ikemTraining. */
export const isIkemTrainingRegistrationOpen = (): boolean => new Date() <= new Date(IkemTraining.registrationEnds);

// The IKEM training is held in Czech, so it is advertised in the Czech and
// Slovak versions only. The root path resolves to Czech, hence the empty check.
export const showsIkemTraining = (language?: string): boolean => {
  const isLocalLanguage = !language || language.startsWith('cs') || language.startsWith('sk');

  return isIkemTrainingAnnounced() && isLocalLanguage;
};
